<template>
  <el-main class="common-main">
    <div class="container">
      <el-row class="tac" :gutter="20">
        <el-col :span="4">
          <TheLeft></TheLeft>
        </el-col>
        <el-col :span="20">
          <div class="order-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="全部提问" name="0"></el-tab-pane>
              <el-tab-pane label="待反馈" name="1"></el-tab-pane>
              <el-tab-pane label="已完成" name="2"></el-tab-pane>
            </el-tabs>
            <div class="order-box" v-loading="loading">
              <div class="order-list" v-if="asks.length > 0">
                <div class="order-item" v-for="(item, index) in asks" :key="index">
                  <div class="order-item-header">
                    <div>编号：{{ item.id }}</div>
                    <div>{{ item.created_at }}</div>
                    <i class="el-icon-error order-item-close" @click="deleteAsk(index)"></i>
                  </div>
                  <div class="order-item-content problem-line">
                    <el-row :gutter="20">
                      <el-col :span="3">
                        <span class="problem-tag">提问标题</span>
                      </el-col>
                      <el-col :span="21">
                        {{ item.title }}
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="problem-user">
                      <el-col :span="3">
                        <span class="problem-tag">提问内容</span>
                      </el-col>
                      <el-col :span="21">
                        {{ item.body }}
                      </el-col>
                    </el-row>
                  </div>
                  <div class="order-item-content">
                    <el-row :gutter="20">
                      <el-col :span="3">
                        <span class="problem-tag">答疑反馈</span>
                      </el-col>
                      <el-col :span="21">
                        {{ item.status ? item.reply : '等待反馈' }}
                      </el-col>
                      <div class="problem-reply_at" v-if="item.reply_at">
                        反馈时间：{{ item.reply_at }}
                      </div>
                    </el-row>
                  </div>
                </div>
              </div>
              <div class="empty" v-if="page_meta.total === 0">
                <div>
                  <img src="../../static/images/empty.png" alt="暂无数据" class="empty-img">
                  <div class="empty-title">暂无数据</div>
                </div>
              </div>
            </div>
            <div class="list-pagination" v-if="asks.length > 0">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="page_meta.per_page"
                  :total="page_meta.total">
              </el-pagination>
            </div>
            <div class="my-ask">
              <el-button type="default" size="mini" @click="clearAsk">清空提问</el-button>
              <el-button type="primary" size="mini" @click="openShowAsk">我要提问</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="我要提问" :visible.sync="showAsk">
      <el-form :model="form" :rules="rules" ref="askForm">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="body">
          <el-input type="textarea" :rows="4" v-model="form.body" placeholder="请输入内容" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAsk = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('askForm')" :loading="saveLoading" :disabled="saveLoading">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import TheLeft from "@/components/layouts/TheLeft";
import {authRequest} from "@/utils/request";

export default {
  name: "userAsk",
  head: {
    title: "我的提问"
  },
  components: {
    TheLeft
  },
  data() {
    return {
      activeName: '0',
      path: process.env.VUE_APP_FILE,
      noneImg: process.env.VUE_APP_NONE,
      asks: [],
      page: 1,
      page_meta: [],
      loading: false,
      showAsk: false,
      form: {
        title: '',
        body: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
        ],
        body: [
          {required: true, message: '请输入内容', trigger: 'blur'},
        ],
      },
      saveLoading: false
    }
  },
  created() {
    this.getAsks()
  },
  methods: {
    handleClick(tab, event) {
      this.getAsks(true)
    },
    async getAsks(reset = false) {
      this.loading = true
      if (reset) {
        this.page = 1
      }
      try {
        let response = await authRequest('user/ask', {
          method: 'GET',
          params: {
            page: this.page,
            type: this.activeName
          }
        })
        let asks = response.data
        this.asks = asks.data
        this.page_meta = asks.meta
        this.loading = false
      } catch (e) {

      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.getAsks()
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          try {
            let response = await authRequest('ask', {
              method: 'POST',
              data: this.form
            })
            this.$message.success('提交成功')
            this.showAsk = false
            this.getAsks(true)
            this.saveLoading = false
          }catch (e) {
            this.saveLoading = false
          }
        } else {
          return false;
        }
      });
    },
    openShowAsk() {
      if (this.$refs['askForm'] !== undefined) {
        this.$refs['askForm'].resetFields()
      }
      this.showAsk = true
    },
    deleteAsk(index) {
      this.$confirm('确认要删除该提问记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        let id = this.asks[index].id
        try {
          await authRequest('ask/' + id, {
            method: 'DELETE'
          })
          this.$message.success('删除成功')
          this.asks.splice(index, 1)
        } catch (e) {

        }
      }).catch(() => {

      });
    },
    clearAsk() {
      this.$confirm('您确定要清除所有提问吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        try {
          await authRequest('ask/clear/all', {
            method: 'POST'
          })
          this.$message.success('清除成功')
          this.getAsks()
        } catch (e) {

        }
      }).catch(() => {

      });
    }
  }
}
</script>

<style scoped>
.order-content {
  background-color: #ffffff;
  padding: 10px 20px;
  position: relative;
}

.order-item {
  border: 1px solid #ebebeb;
  margin-bottom: 20px;
  border-radius: 5px;
}

.order-item-header {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-size: 14px;
  border-bottom: 1px solid #ebebeb;
  background-color: #f3f3f3;
  position: relative;
}

.order-box {
  min-height: 400px;
}

.order-item-content {
  padding: 20px;
  font-size: 14px;
}

.order-item-footer-status span {
  margin-left: 20px;
}

.problem-tag {
  background-color: #2aacb2;
  padding: 2px 5px;
  border-radius: 3px;
  color: #ffffff;
}

.problem-line {
  border-bottom: 1px solid #ebebeb;
}

.problem-reply_at {
  text-align: right;
  margin-top: 5px;
}

.problem-user {
  margin-top: 10px;
}

.my-ask {
  position: absolute;
  right: 20px;
  top: 10px;
}

.order-item-close {
  position: absolute;
  right: -5px;
  top: -5px;
  font-size: 20px;
  color: #6e6e6e;
  cursor: pointer;
}

.order-item-close:hover {
  color: #F56C6C;
}
</style>
